import JSZip from 'jszip';

export interface DocxXmlParts {
  documentXml: string;
  numberingXml: string | null;
  stylesXml: string | null;
}

export async function readDocxXmlParts(arrayBuffer: ArrayBuffer): Promise<DocxXmlParts> {
  const zip = await JSZip.loadAsync(arrayBuffer);

  const documentFile = zip.file('word/document.xml');
  if (!documentFile) {
    throw new Error('word/document.xml not found - not a valid docx file');
  }

  const numberingFile = zip.file('word/numbering.xml');
  const stylesFile = zip.file('word/styles.xml');

  const [documentXml, numberingXml, stylesXml] = await Promise.all([
    documentFile.async('text'),
    numberingFile ? numberingFile.async('text') : Promise.resolve(null),
    stylesFile ? stylesFile.async('text') : Promise.resolve(null),
  ]);

  return { documentXml, numberingXml, stylesXml };
}
